import { render, staticRenderFns } from "./AuthenticationPage.vue?vue&type=template&id=6c46c7cd&scoped=true&lang=pug&"
import script from "./AuthenticationPage.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationPage.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationPage.vue?vue&type=style&index=0&id=6c46c7cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c46c7cd",
  null
  
)

export default component.exports